import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface UserReferralData {
  id: number;
  userName: string;
  email: string;
  phoneNumber: string;
  createdDate: string;
  refferedBy: string | null;
  status: boolean;
  referralCount: number;
}

export interface ReferralDetailsResponse {
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  data: UserReferralData[];
}

export const GetAllUsersReferalDetails = async (
  pageNumber: number,
  pageSize: number,
  search: string,
  token: string
): Promise<ReferralDetailsResponse> => {
  const baseUrl = getApiBaseUrl();

  const apiUrl =
    `${baseUrl}/api/Admin/GetAllUsersReferalDetails` +
    `?pageNumber=${pageNumber}` +
    `&pageSize=${pageSize}` +
    `&search=${encodeURIComponent(search)}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch referral details");
    }

    return await response.json();
  } catch (error) {
    console.error("Error in GetAllUsersReferalDetails:", error);
    throw error;
  }
};
